export const handleNotification = (notifyType, assetApproved, approvalQty = 'N/A') => {
  if (notifyType === 'success') {
    const approvalVerb = assetApproved ? bfTranslate('Approved') : bfTranslate('Unapproved');
    const approvalCopy = approvalQty === 1 ? bfTranslate('total approval') : bfTranslate('total approvals');
    const bodyText = (approvalQty === 'N/A' || !approvalQty)
      ? ''
      : `${bfTranslate('This asset requires')} ${approvalQty} ${approvalCopy}. ${assetApproved ? bfTranslate('All previous approvals are void.') : ''}`;

    Notify.create({
      title: `${approvalVerb} ${bfTranslate('1 asset')}!`,
      body: bodyText,
      type: 'success'
    });
  }

  if (notifyType === 'error') {
    const approvingErrorCopy = bfTranslate('An error occurred when approving assets.');
    const unapprovingErrorCopy = bfTranslate('An error occurred when unapproving assets.');

    Notify.create({
      title: `${assetApproved ? approvingErrorCopy : unapprovingErrorCopy} ${bfTranslate('Please try again.')}`,
      type: 'error'
    });
  }
};

export const sweetAlertUnapproveOptions = {
  title: bfTranslate('This asset has external links.'),
  text: bfTranslate('Are you sure you want to unapprove? Unapproving will cause broken image links on sites that depend on the availability of this asset. Check the usage tab to see active external links before unapproving.\n\n'),
  type: 'warning',
  showCancelButton: true,
  cancelButtonText: 'Cancel',
  confirmButtonText: 'Unapprove',
  closeOnConfirm: true,
  customClass: 'merging'
};
